export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'DK',
  'merchantReturnLink': 'TBD',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
